import { useEffect } from 'react';
import { getRedirectResult } from 'firebase/auth';
import './authentication.scss'
import {SignInForm} from '../../components/sign-in-form/sign-in-form'
import {SignUpForm} from '../../components/sign-up-form/sign-up-form'
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
import {
  auth,
  signInWithGooglePopup,
  signInWithGoogleRedirect,
  createUserProfileDocument,
  createUserDocumentFromAuth
} from '../../utils/firebase/firebase.utils';

const Authentication = () => {

  useEffect( async()=>{ // when it mounts for the first time
    const res = await getRedirectResult(auth);
    console.log("authenticationres = ", res);
    if(res){
      const userDocRef = await createUserDocumentFromAuth(res);
    }
  },[])

//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  return (
    <div>
      <div className='btnsContainer'>
      </div>
      <div className='forms'>
        <SignInForm/>
        <SignUpForm/>
      </div>
    </div>
  );
};

export default Authentication;
